module.exports = __webpack_public_path__ + "img/logo_large2.40dbee01.png";